export default __webpack_public_path__ + "icons/whaleSuccess-112f4c.svg";